// Libs
import React from 'react';
import { useSelector } from 'react-redux';
import { xlsx } from 'utils/libs';
import {
	selectDataFilters,
	selectDatasourceFields,
	selectDatasourceSingleData,
	selectSelectedProject,
	selectSelectedDataFilterId,
} from 'core/selectors';
import { selectSelectedSubModule } from 'components/Modules/selectors';
import { selectProfile } from 'screens/Login/selectors';
import MODULE_KEYWORDS from 'components/Modules/keywords';
import { canImportGponPricingSignals } from 'core/ElementViewBuilder/views/Billing/Payment/paymentSummaryCapabilities';
// Components
import { Dropdown, ExcelIcon, Menu } from 'components';
import {
	getExportName,
	getExportSheetName,
	getSafeExportName,
	projectDatasourceForExport,
} from './DataExport.utils';
import PricingSignalsImportModal from './PricingSignalsImportModal';

const DataExport = ({
	datasource,
	fields: providedFields,
	fileName: providedFileName,
}) => {
	const [isImportModalOpen, setIsImportModalOpen] = React.useState(false);
	const datasourceFields = useSelector(selectDatasourceFields);
	const datasourceSingleData = useSelector(selectDatasourceSingleData);
	const dataFilters = useSelector(selectDataFilters);
	const selectedDataFilterId = useSelector(selectSelectedDataFilterId);
	const selectedProject = useSelector(selectSelectedProject);
	const selectedSubModule = useSelector(selectSelectedSubModule);
	const profile = useSelector(selectProfile);
	const { BILLINGS } = MODULE_KEYWORDS.MODULES.ITEMS.KEYS;
	const selectedDatasource = dataFilters.find(
		dataFilter => dataFilter.id === selectedDataFilterId,
	);
	const isPaymentsModule = selectedSubModule?.key === BILLINGS.PAYMENTS;
	const canImportSignals =
		isPaymentsModule &&
		canImportGponPricingSignals({
			profile,
			project: selectedProject,
			isInvoice: false,
		});
	const fileName = getSafeExportName(
		providedFileName ||
			getExportName({
				moduleName: selectedSubModule?.name,
				datasourceName: selectedDatasource?.name,
			}),
	);
	const sheetName = getExportSheetName(fileName);
	const effectiveExportConfig = datasourceSingleData?.exportConfig;
	const configuredExportConfig = selectedDatasource?.config?.export;
	const exportConfig = providedFields
		? undefined
		: effectiveExportConfig !== undefined
			? effectiveExportConfig
			: configuredExportConfig?.version === 1
				? configuredExportConfig
				: undefined;
	const data = projectDatasourceForExport({
		datasource,
		fields: providedFields || datasourceFields,
		profile,
		exportConfig,
	});

	const handleExport = () =>
		xlsx.exportMultiSheetToExcel(fileName, [
			{
				name: sheetName,
				data,
			},
		]);

	if (!canImportSignals) {
		return <ExcelIcon button onClick={handleExport} />;
	}

	const menu = (
		<Menu.Wrapper>
			<Menu.Item onClick={handleExport}>Exportar tabla</Menu.Item>
			<Menu.Item onClick={() => setIsImportModalOpen(true)}>
				Importar señales GPON
			</Menu.Item>
		</Menu.Wrapper>
	);

	return (
		<>
			<Dropdown.Wrapper
				trigger={['click']}
				overlay={menu}
				placement='bottomRight'
			>
				<span>
					<ExcelIcon button />
				</span>
			</Dropdown.Wrapper>
			<PricingSignalsImportModal
				visible={isImportModalOpen}
				onClose={() => setIsImportModalOpen(false)}
			/>
		</>
	);
};

export default DataExport;
